import React, { createContext, useState, useEffect } from 'react'
import LocalStorage from '../services/LocalStorage'

const UnitSystemContext = createContext()
export default UnitSystemContext

export function UnitSystemProvider(props) {

    const [unitSystem, setUnitSystem] = useState(LocalStorage.getItem('unitSystem') || 'metric')

    useEffect(() => {
        if (!unitSystem) return
        LocalStorage.setItem('unitSystem', unitSystem)
    }, [unitSystem])

    return (
        <UnitSystemContext.Provider
            value={{
                unitSystem,
                setUnitSystem,
            }}
            {...props}
        />
    )
}